function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__top-left">
                <div className="product-info__title title-def title-def_sec3">Эмульсия гидрофобизирующая<br/> RUTESIL® 5094</div>
              </div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/12.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Эмульсия  гидрофобизирующая  Rutesil® 5094  представляет  собой  эмульсию полиметилгидридсилоксана в воде.</p>
              <p>Эмульсию применяют для придания гидрофобных свойств различным тканям, бумаге, строительным материалам и коже; для улучшения влагостойкости асбоцементных и гипсокартонных плит, керамических материалов, фарфоровых и стеклянных изоляторов; для приготовления антиадгезионных смазок для стеклоформующих поверхностей.</p>
              <p>Эмульсия не изменяет внешний вид обработанных ею материалов, не препятствует нормальному воздухообмену конструкции, способствует уменьшению загрязняемости фактурного слоя, увеличивает срок службы материалов и конструкций. Покрытие препятствует снижению теплоизоляционных свойств материалов, обладает хорошей стойкостью во времени к действию различных факторов, в том числе попеременного замораживания и оттаивания.</p>
              <p></p>
              <h4>Основные характеристики</h4>
              <p>Внешний вид:   эмульсия белого цвета</p>
              <p>Содержание активного вещества:  не менее 50%</p>
              <p>Плотность при 25°C, прибл.1,0 г/см куб.</p>
              <p>Стабильность при разведении:  не менее  12 ч </p>
              <p>рН: 3-6</p>
              <p></p>
              <h4>Упаковка</h4>
              <p>Контейнеры IBC объемом 1 м куб.</p>
              <p></p>
              <h4>Гарантийный срок хранения</h4>
              <p>6 месяцев со дня изготовления.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;